import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HelpNavigationService } from '../services/help-navigation.service';

@Component({
  selector: 'app-help-charities',
  imports: [CommonModule],
  templateUrl: './help-charities.component.html',
  styleUrl: './help-charities.component.scss'
})
export class HelpCharitiesComponent implements OnInit {


  selectedSection = 'createcharity';
  charitiesExpanded = true;
  createCharityExpanded = true;

  constructor(
    private navigationService: HelpNavigationService
  ) { }

  ngOnInit(): void {

    this.navigationService.selectedSection.next('createcharity');

    this.navigationService.selectedSection.subscribe(section => {

      this.selectedSection = section;

      setTimeout(() => {

        const element =
          document.getElementById(section);

        const container =
          document.querySelector('.help-content') as HTMLElement;

        if (element && container) {

          container.scrollTo({
            top: element.offsetTop - 40,
            behavior: 'smooth'
          });

        }

      }, 50);

    });

  }

  toggleCharitiesMenu(): void {
    this.charitiesExpanded = !this.charitiesExpanded;
  }

  toggleCreateCharityMenu(): void {
    this.createCharityExpanded = !this.createCharityExpanded;
  }


  changeSection(section: string): void {

    this.selectedSection = section;

    this.navigationService.selectedSection.next(section);

    setTimeout(() => {

      const element =
        document.getElementById(section);

      element?.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });

    }, 50);

  }
}
